<template>
   <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card v-if="!showCollections">
      <v-toolbar dark color="primary" dense>
        <v-toolbar-title class="text-body-1">
          Subscription History
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-divider></v-divider>
        <div class="row">
          <div class="col">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="width:300px" class="text-left">Name</th>
                    <th style="width: 200px">Start Date</th>
                    <th class="text-left">End Date</th>
                    <!-- <th class="text-right"> Details</th>
                    <th class="text-right"></th> -->
                    <!-- <th class="text-left">StartTime</th> -->
                    <!-- <th class="text-left">EndTime</th> -->
                    <!-- <th style="width:100px" class="text-left">Is Success</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in list" :key="item.id" >
                    <td>{{ item.Name }}</td>
                    <td>{{ item.startDate | dateUtcToLocal }}</td>
                    <td>{{ item.CancelDate ? item.CancelDate : item.endDate | dateUtcToLocal }}</td>
                    <!-- <td>{{ item.PurchaseDetails.length > 0 ? item.PurchaseDetails[0].StartDate : '' | dateUtcToLocal}}</td>
                    <td>{{ item.PurchaseDetails.length > 0 ? item.PurchaseDetails[0].EndDate : '' | dateUtcToLocal}}</td>
                    <td class="text-right">
                      <v-btn text small @click="showIndividualCollections(item)"><v-icon small color="blue darken-2"> mdi-domain </v-icon></v-btn>
                    </td> -->
                    <!-- <td class="text-right">
                      <v-btn text small @click="onCancel(item)"><v-icon small color="red"> mdi-cancel </v-icon></v-btn>
                    </td> -->
                    <!-- <td>{{ item.StartTime | formatTime }}</td> -->
                    <!-- <td>{{ item.EndTime | formatTime}}</td> -->
                    <!-- <td class="text-center">
                       <v-icon v-show="item.isSuccess">mdi-check</v-icon>
                       <v-icon v-show="item.isSuccess == false">mdi-close</v-icon>
                    </td> -->
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-btn @click.native="cancel" v-if="!options.noconfirm"> Close </v-btn>
      </v-card-actions>
      <ConfirmationDialog ref="confirm" />
    </v-card>
    <v-card v-else>
      <v-toolbar dark color="primary" dense>
        <v-toolbar-title class="text-body-1">
          Subscription History
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-divider></v-divider>
        <div class="row">
          <div class="col">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="width:300px" class="text-left">Name</th>
                    <th style="width: 500px">Description</th>
                    <th style="width: 200px">Start Date</th>
                    <th class="text-left">End Date</th>
                    <!-- <th class="text-left">StartTime</th> -->
                    <!-- <th class="text-left">EndTime</th> -->
                    <!-- <th style="width:100px" class="text-left">Is Success</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in individualCollections" :key="item.id" >
                    <td>{{ item.Name }}</td>
                    <td>{{ item.Description }}</td>
                    <td>{{ item.startDate | dateUtcToLocal}}</td>
                    <td>{{ item.endDate | dateUtcToLocal}}</td>
                    <!-- <td>{{ item.StartTime | formatTime }}</td> -->
                    <!-- <td>{{ item.EndTime | formatTime}}</td> -->
                    <!-- <td class="text-center">
                       <v-icon v-show="item.isSuccess">mdi-check</v-icon>
                       <v-icon v-show="item.isSuccess == false">mdi-close</v-icon>
                    </td> -->
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-btn @click.native="() => { showCollections = false; }" v-if="!options.noconfirm"> Back </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import * as api from "@/api";
import ConfirmationDialog from "@/components/ConfirmationDialog";
export default {
  name: 'FulfillmentStatus',
  components: {
    ConfirmationDialog
  },
  computed: {
    // orderedList() {
    //   return this.list;
    // },
  },
  created() {
    
  },
  methods: {
    open(list) {
        this.dialog = true;
        this.list = list;
        console.log("list",list);
    },
    cancel() {
        this.dialog = false;
        this.list = [];
    },
    getItemDetails(id, isCollection) {
      console.log("id", id, "isCollection", isCollection);
      let that = this;
      let url =
        Boolean(isCollection) == true
          ? "purchase-order/collection/" + id
          : "purchase-order/publication/" + id;
      that.individualCollections.splice(0, that.individualCollections.length);
      new Promise((resolve, reject) => {
        api
          .getByPagin(url, { count: 10, page: 1, size: 1000, keyword: ""})
          .then(response => {
            if (
              response.data != null &&
              response.data.data != null &&
              response.data.data.length > 0
            ) {
              response.data.data.forEach(e => {
                that.individualCollections.push(e);
              });
              this.showCollections = true;
            } else {
              console.warn("No Collection Details found");
              console.warn(response.data.data);
            }
          })
          .catch(error => {
            reject(error);
            that.overlay = false;
          });
      });
    },
    showIndividualCollections(item) {
      this.individualCollections = [];
      this.getItemDetails(item.id, item.IsCollection);
    },
    async onCancel(item) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to cancel this record?"
        )
      ) {
        window.location = `/purchaseOrderCancel/${item.id}/${item.OrganizationId}/${item.IsCollection}`;
      }
    },
  },
  props: {
  },
  computed: {
  },
  watch: {
    notify() {
    },
  },
  data() {
    return {
      showCollections: false,
      list: [],
      individualCollections: [],
      dialog: false,
      options: {
        color: "primary",
        width: 1200,
        zIndex: 200,
        noconfirm: false,
      },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/FulfillmentStatus.vue